module.exports = __webpack_public_path__ + "static/media/safe-logo-link.a629c7b2.svg";